<script setup lang="ts">

const props = defineProps({
  /** utilize:
         * - **svg:nome-arquivo** para utilizar svg
         * - **lottie:nome-arquivo** para utilizar lottie
         * -  https://icones.js.org/ ex: material-symbols:edit-sharp
        **/
  name: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: '1em'
  },
  color: {
    type: String,
    default: 'currentColor'
  },
  spin: {
    type: Boolean,
    default: false
  }
})
const iconName = computed(() => {
  if (props.name?.startsWith('svg:')) {
    return props.name.replace('svg:', 'svgo-')
  }
  if (props.name?.startsWith('lottie:')) {
    return props.name.replace('lottie:', '').replace('.json', '')
  }
  if (props.name?.endsWith('.json')) {
    return props.name.replace('lottie:', '').replace('.json', '')
  }
  return props.name
})
</script>
<template>
  <component
    :is="iconName"
    v-if="props.name?.startsWith('svg')"
    :style="{fontSize:props.size}"
    :color="props.color"
    class="inline-block"
    :class="{'animate-spin':props.spin}"
  />
  <UiLottie
    v-else-if="props.name?.startsWith('lottie') || props.name?.endsWith('json')"
    v-bind="$attrs"
    :src="'/lotties/'+iconName+'.json'"
    :size="props.size"
    :color="props.color"
    play-on-hover
    :class="{'animate-spin':props.spin}"
  />
  <Icon
    v-else
    :name="props.name"
    :size="props.size"
    :color="props.color"
    :class="{'animate-spin':props.spin}"
  />
</template>
<style lang="scss" scoped>
  .animate-spin {
    animation: spin 1s linear infinite;
  }
    @keyframes spin {
        0% {
        transform: rotate(0deg);
        }
        100% {
        transform: rotate(359deg);
        }
    }
</style>
